import { Menu, MenuItem, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  anchorEl: any | null;
  menuOpen: boolean;

  handleOpenDeleteContactPermanentlyDialog(): void;

  handleOpenChangeAiJudgementDialog(): void;

  handleRemoveContactFromBlacklist?(): void;

  handleRemoveContactFromSuspended?(): void;

  handleOpenUpdateSexDialog?(): void;

  handleRecoverContactFromDeleted?(): void;

  handleCloseMenu(): void;
}

const ContactItemMenu: React.FC<Props> = ({
  anchorEl,
  menuOpen,
  handleOpenDeleteContactPermanentlyDialog,
  handleOpenChangeAiJudgementDialog,
  handleRemoveContactFromBlacklist,
  handleRemoveContactFromSuspended,
  handleOpenUpdateSexDialog,
  handleRecoverContactFromDeleted,
  handleCloseMenu,
}) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      classes={{ list: classes.menuList, paper: classes.menuPaper }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          style: {
            width: 'auto',
          },
        },
      }}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableAutoFocusItem={true}
      disableRestoreFocus={true}
    >
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleOpenChangeAiJudgementDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('changeAiJudgement')}</Typography>
      </MenuItem>
      {!_.isNil(handleRemoveContactFromBlacklist) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleRemoveContactFromBlacklist();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('removeFromBlacklist')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleRemoveContactFromSuspended) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleRemoveContactFromSuspended();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('removeFromSuspended')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleOpenUpdateSexDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenUpdateSexDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('updateSex')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleRecoverContactFromDeleted) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleRecoverContactFromDeleted();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('recoverFromDeleted')}</Typography>
        </MenuItem>
      ) : (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenDeleteContactPermanentlyDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={cx(classes.menuItemText, 'delete')}>{t('deleteFunnelContact')}</Typography>
        </MenuItem>
      )}
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '6px',
    maxHeight: '33vh',
    width: '100%',
    marginLeft: '8px',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(15),
    borderBottom: `1px solid ${theme.palette.greys.lighter}`,
    padding: '6px 16px',
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: theme.palette.action.hover,
    },
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main,
    },
  },
}));

export default ContactItemMenu;
